export default {"id":"4bf596ce","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}